import { render, staticRenderFns } from "./CompanionModels.vue?vue&type=template&id=1624d960&"
import script from "./CompanionModels.vue?vue&type=script&lang=js&"
export * from "./CompanionModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports